import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EmployeeService } from "../employee-profile/employee-profile.service";
import { SharedSkillService } from "./shared-skill.service";
import { SkillRepositoryService } from "./skill-repository.service";
import { Location } from '@angular/common';
import { AuthServiceService } from "src/app/services/auth-service.service";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { CompetenciesService } from "../competencies/competencies.service";
import { map, switchMap } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import domToImage from 'dom-to-image';
import jsPDF from 'jspdf';
import * as moment from 'moment';


@Component({
  selector: "app-skill-repository",
  templateUrl: "./skill-repository.component.html",
  styleUrls: ["./skill-repository.component.css"],
})

export class SkillRepositoryComponent implements OnInit {
  dotColors = ['rgb(164 201 228)', 'rgb(204 210 214)', 'rgb(147 237 187)', 'rgb(238 108 106)'];
  flip = [];
  role: string;
  adminRole: number = 0;
  toggleState: boolean = true;
  flipSubcomp: any;
  hide:boolean=false;
  loader: boolean = false;
  private debounceTimeout: any;
  flipSubcompe: any
  flipSubcompen: any
  @ViewChild('dataToExport', { static: false }) public dataToExport: ElementRef;
  isExport = false;
  flipSubcompentencydownload = []
  noResultsFound: boolean = false;

  constructor(
    private employeeService: EmployeeService,
    private skillRepoService: SkillRepositoryService,
    private _router: Router,
    private activaroute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private sharedSkillService: SharedSkillService,
    private _service: CompetenciesService,
    private _location: Location,
    private auth: AuthServiceService
  ) { }

  ngOnInit() {
    this.role = this.auth.getRole();
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 1;
    }
    this.fetchCompetencies();
  }

  dataWithCount = [];
  subdataWithCount = []
  showCards: boolean = false;
  public from: number;
  CMPID: number;
  public size: number = 1000;
  public data: any = [];
  showviewMore: boolean = false;
  noHeader: any;
  loading: boolean = false;
  searchText: string = "";
  apiLookup = {
    sme: "getAllSMEs",
    certified: "getAllCertifiedResources",
    available: "getAllAvailableResources",
    allocatedResources: "getAllAvailableResources",
    all: "getAllAvailableResources",
    "pending-certifications": "getAllCertificationInProgressResources", "getEmployeesByCompId": "FetchEmployeesbyCompetencyId",
    "getFilteredResources": "GetFilteredResources",
    competency: "getAvailableProfilesbyCompetencyId",
    search: "getEmployees",
  };
  uiCountLookup: Object = {
    sme: "SMEs",
    certified: "Certified",
    available: "Bench Pool",
    pendingCertifications: "Ongoing Certifications",
    allocatedResources: "Allocated Resources",

  };

  subTitle: Object = {
    sme: "Expert level Resources",
    certified: "Certified Resources",
    available: "Bench Pool Resources",
    pendingCertifications: "Ongoing Certifications",
    allocatedResources: "Allocated Resources",
  };

  navigateToEmployees(key, competency, competencyId) {

    //todo: use shared service instead of localstorage
    localStorage.setItem("compApiType", key);
    localStorage.setItem("compId", competencyId);
    localStorage.setItem("compTitle", competency);
    localStorage.setItem("compSubTitle", this.subTitle[key]);
    if (key == "allocatedResources")
      this.sharedSkillService.setAvailability(false);
    else if (key == "available") this.sharedSkillService.setAvailability(true);
    else this.sharedSkillService.setAvailability("-1");
    this.sharedSkillService.setSubComp("");
    this.sharedSkillService.setSubCompId("");
    this.sharedSkillService.setSearchText(this.searchText);
    this.skillRepoService.updateSharedVariable({ message: competencyId, compTitle: competency })
    this._router.navigate([`/Home/Skill Repository/${competency}`]);
  }

  navigateToSkilldata(key, competency, competencyId, name) {
    const value = 3;
    sessionStorage.setItem("resource", String(value))
    sessionStorage.setItem("compId", competencyId);
    sessionStorage.setItem("comptitle", competency)
    this.sharedSkillService.setpagenavigationId({
      resource: value,
      competencyId: competencyId
    });

    localStorage.setItem("compApiType", "All");
    localStorage.setItem("compId", competencyId);
    localStorage.setItem("comptitle", competency);
    localStorage.setItem("approvedata", name);
    localStorage.setItem("compSubTitle", this.subTitle[key]);

    if (key == "allocatedResources")
      this.sharedSkillService.setAvailability(false);
    else if (key == "available") this.sharedSkillService.setAvailability(true);
    else this.sharedSkillService.setAvailability("-1")
    this.sharedSkillService.setSubComp("");
    this.sharedSkillService.setSubCompId("");
    this.sharedSkillService.setSearchText(this.searchText);
    this.skillRepoService.updateSharedVariable({ message: competencyId, compTitle: competency, compName: name })
    this._router.navigate([`/Home/Skill Repository/${competency}/${name}`]);
  }

  searchButton() {
    const specialCharacterPattern = /[^a-zA-Z0-9\s]/; 
    if (this.searchText != '') { 
        if (specialCharacterPattern.test(this.searchText)) {
            // alert('Special characters are not allowed in the search field!'); 
            return; 
        } 
        this.hide = true; 
        this.sharedSkillService.setSearchText(this.searchText); 
        this.from = 0; 
        this.size = 6; 
        this.loadEmployees(false); 
    }
    if (this.data.length === 0){
      this.noResultsFound = true;
    }
    else {
      this.noResultsFound = false;
    }
  }

  showTooltip: boolean = false;

validateSearchText() {
  const specialCharacterPattern = /[^a-zA-Z0-9\s]/;
  this.showTooltip = specialCharacterPattern.test(this.searchText); 
}


  loadEmployees(viewmore) {
    if (
      this.employeeService) {
      this.employeeService.searchEmployee(
        this.from,
        this.size,
        this.searchText
      ).subscribe(
        (x) => {
          if (viewmore) {
            if (this.CMPID == 3) { this.data = this.data.concat(x.data.items); }
            else {
              this.data = this.data.concat(x.data.items);
            }
          }
          else {
            if (this.CMPID == 3) {
              this.data = x.data.items;
            }
            else { this.data = x.data.items; }

          }
          if (this.data.length <= x.data.total) this.showviewMore = false;
          this.showCards = true;

          if (x.data.total > this.from + this.size) this.showviewMore = true;
          this.loader = false;

        },
        (error) => {
          this.loader = false;
        }
      );
    }
  }

  viewMore() {
    this.from += this.size;
    this.loader = true;
    this.showviewMore = false;
    this.loadEmployees(true);
  }


  defaultTileNavigation(comp, event) {

    event.preventDefault();
    const value = 3;
    sessionStorage.setItem("resource", String(value))
    sessionStorage.setItem("compId", comp.id);
    sessionStorage.setItem("comptitle", comp.title)
    this.sharedSkillService.setpagenavigationId({ resource: value });
    localStorage.setItem("compId", comp.id);
    localStorage.setItem("comptitle", comp.title);
    this.navigateToEmployees("all", comp.title, comp.id);
  }



  clearSearchText() {
    this.searchText = "";
    this.fetchCompetencies();
    this.noResultsFound = false;

  }
  clearSearchText1() {
    this.searchText = "";
    this.hide=false;
    this._router.navigate(['Home/Skill Repository'])
    this.showviewMore = false;
    this.showCards = false;
  }



  getStar(index, totalCount, indiCount) {

    let actualPer = indiCount / totalCount;
    let reqPer = actualPer * 500;
    reqPer = reqPer - (index - 1) * 100;
    if (totalCount <= 0 || indiCount <= 0) return "zero star fa fa-star";
    if (reqPer > index * 100) return "full star fa fa-star";
    else {
      if (index * 100 - reqPer >= 75) return "quarter star fa fa-star";
      else if (index * 100 - reqPer == 50) return "half star fa fa-star";
      else if (index * 100 - reqPer <= 50)
        return "past-quarter star fa fa-star";
    }
  }

  getImageSrc(name) {
    switch (name) {
      case "Digital Engineering":
        return "../../../assets/images/updated-icons/Digital.png";
      case "Data Service":
        return "../../../assets/images/updated-icons/dataServices.png";
      case "Cognitive Service":
        return "../../../assets/images/updated-icons/cognative.png";
      case "Cloud Services":
        return "../../../assets/images/updated-icons/Cloud.png";
      case "Cyber Security":
        return "../../../assets/images/updated-icons/cyber_security.png";
      case "Emerging Technologies":
        return "../../../assets/images/updated-icons/emergin.png";
      case "Infrastructure & Managed Services":
        return "../../../assets/images/updated-icons/Infrastructure.png";
      case "PMO Services":
        return "../../../assets/images/updated-icons/PMO.png";
    }

  }


  fetchCompetencies() {
    this.loading = true;
    this.togglecomptencies = [];
    this.dataWithCount = [];
    this.skillRepoService
      .GetEmployeesCountByCompetency(this.searchText)
      .subscribe(
        (response) => {
          let result = response.data;
          result.map((res) => {
            let finalObj: any = {};
            finalObj.title = res.competencyName;
            finalObj.filledCount = res.filledCount;
            finalObj.count = res.totalCount;
            finalObj.id = res.competencyId;
            finalObj.skillData = [
              { name: 'Submitted', count: res.submittedCount },
              { name: 'Not Submitted', count: res.notSubmittedCount },
              { name: 'Approved', count: res.approvedCount },
              { name: 'Rejected', count: res.rejectedCount }
            ];
            this.dataWithCount.push(finalObj);
          });
          for (let x = 0; x <= this.dataWithCount.length; x++) {
            this.togglecomptencies.push(true);
            this.flip.push('inactive');
          }
          this.loading = false;
        },

        (error) => {
          this.dataWithCount = [];
          this.cd.detectChanges();
        }
      );
  }

  togglecomptencies = [];
  toggelcondition(value) {
    let i = this.togglecomptencies[value]
    return i
  }

  pdfData() {
    this.flipSubcompen = []
    this.flipSubcompe = [];
    for (let i = 0; i <= this.dataWithCount.length; i++) {
      this.skillRepoService.GetResourceCountBySubCompetency(i).subscribe((x) => {
        this.flipSubcompen = x.data;
        this.flipSubcompe = this.flipSubcompen
      });
    }
  }
  onMouseEnter(value) {

    if (this.debounceTimeout !== null) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.toggleState = !this.toggleState;

      if (this.flip[value] == "inactive") {
        for (let x = 0; x < this.flip.length; x++) {
          this.togglecomptencies[x] = "inactive";
        }
        this.flip[value] = "active";
      } else {
        this.flip[value] = "inactive";
      }

      let i = this.togglecomptencies[value];
      if (i) {
        for (let x = 0; x < this.togglecomptencies.length; x++) {
          this.togglecomptencies[x] = true;
        }
        this.togglecomptencies[value] = false;
      } else {
        this.togglecomptencies[value] = true;
      }

      if (!this.togglecomptencies[value]) {
        this.loading = true;
        this.flipSubcomp = [];
        this.skillRepoService.GetResourceCountBySubCompetency(value).subscribe((x) => {
          this.flipSubcomp = x.data;
        });
      }
    },);
  }

  toggleCompetency(competencyId: number) {
    if (this.toggleState) {
      this.fetchSubCompetencies(competencyId);
    } else {
    }
    this.toggleState = !this.toggleState;
  }


  fetchSubCompetencies(competencyId: number) {
    this.loading = true;
    this.dataWithCount = [];
    this._service.getSubCompetenciesForDropDowns(competencyId).pipe(
      switchMap((response) => {
        const result = response.data;
        const countCache = {};
        const countObservables = result.map((res) => {
          const finalObj: any = {};
          finalObj.titlesubcomp = res.name;
          finalObj.titlesubcompid = res.id
          finalObj.titlecomid = res.competencId
          sessionStorage.setItem("titlesubcompname", finalObj.titlesubcomp)
          sessionStorage.setItem("titlesubcompid", finalObj.titlesubcompid)

          if (countCache[finalObj.titlesubcomp]) {
            finalObj.count = countCache[finalObj.titlesubcomp];
            return of(finalObj);
          } else {
            return this._service.GetResourceCount(finalObj.titlecomid, finalObj.titlesubcomp).pipe(
              map((countResponse) => {
                finalObj.count = countResponse.data.totalCount;
                countCache[finalObj.titlesubcomp] = finalObj.count;
                return finalObj;
              })
            );
          }
        });
        return forkJoin(countObservables);
      })
    ).subscribe(
      (dataWithCount) => {
        this.dataWithCount = dataWithCount;
        this.loading = false;
      },
      (error) => {
        this.dataWithCount = [];
        this.cd.detectChanges();
      }
    );
  }

  searchButton1() {

    this.sharedSkillService.setSearchText(this.searchText);
  }

  getGradeColor(grade) {
    switch (grade) {
      case "A":
        return "#77c898";
      case "A+":
        return "#6ac58f";
      case "B":
        return "#A8ECD8";
      case "B+":
        return "#3dcb9e";
      case "C":
        return "#e2eca8";
      case "C+":
        return "#eaf2c0";
    }

  }

  getPadding(grade) {
    switch (grade) {
      case "A":
        return "0px 5px";
      case "A+":
        return "0px 2px";
      case "B":
        return "0px 5px";
      case "B+":
        return "0px 2px";
      case "C":
        return "0px 5px";
      case "C+":
        return "0px 2px";
    }
  }

  navigateBack() {
    this._location.back();
  }

  backButton() {
    this._router.navigate(["/home"])
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    $("#sidebar_r").removeClass("active");
    $("#sidebar").removeClass("active");
    $(".overlay").removeClass("active");
  }

  convertToPdf() {
    this.isExport = true
    this.skillRepoService.GetResourceCountBySubCompetency1().subscribe((res) => {
      this.flipSubcompentencydownload = res.data
      setTimeout(() => {
        this.loading = true
        const contentElement = this.dataToExport.nativeElement;
        const width = contentElement.clientWidth + 5;
        const height = contentElement.clientHeight + 100;
        const orientation = width > height ? 'l' : 'p';

        domToImage.toPng(contentElement)
          .then((dataUrl) => {
            const pdf = new jsPDF({
              orientation: orientation as 'l' | 'p',
              unit: 'pt',
              format: [width + 90, height + 300]
            });

            pdf.setFontSize(35);
            pdf.setTextColor('#131523');
            pdf.text('Skill Repository', 35, 50);

            pdf.setFontSize(25);
            pdf.setTextColor('#131523');
            pdf.text('Report date: ' + moment().format('ll'), 35, 90);

            const imgWidth = width;
            const imgHeight = height;
            const position = 25;

            pdf.addImage(dataUrl, 'PNG', position, position + 70, imgWidth, imgHeight);
            pdf.save("skill-repo" + new Date().getTime() + ".pdf")
            this.loading = false
            this.isExport = false

          })
          .catch((error) => {
            this.isExport = false;
            this.loading = false
          });
      })
    });
  }

  handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.searchText === '') {
      this.searchText = '';
      this._router.navigate(['Home/Skill Repository'])
      this.showviewMore = false;
      this.showCards = false;
      this.hide = false;
    }
  }
}